// IE 2026 10 13 / ODOO-5800 (Igor, dev02, стол 0af_001, отчёт «M03 Marketing plan · CF»): строка «Пимафуцин ваг супп 100мг №6» отмечена в списке → чипс
// «СводнаяНоменклатура: Пимафуцин…», отчёт сужен; затем в форме того же чипса выбрано то же значение из «Недавні» → чипс «СводнаяНоменклатура в Пимафуцин…»,
// отчёт по всем БЮ. Замер ботом (payload select отчёта 0fU_001): id и поле те же, но значение переехало из attrs строки стола в rightValue
// ({condition: 'in', attrs: [], rightValue.value = id}). Бэк берёт значения строки «in» только из attrs (my_database.get_rightValues → attrs.selector_text) —
// пустой список = без отбора. Причина на фронте: запись истории в форме rightValue (снимок строки в такой форме), AttrChips.applyChipHistory брал значения
// только из h.attrs (пусто → путь виджета-селектора пропущен) и фолбэком копировал строку записи как есть.
// Правило: у строки «in» / «!in» значения живут СПИСКОМ в attrs (как пишет onApplySelector__Click), rightValue — плейсхолдер.
// Флаг fe.ux.chipPickKeepsSelector (дефолт ВКЛ); выкл — как было. Юнит tests/unit/chipPickRow.test.mjs
export const CHIP_PICK_KEEPS_SELECTOR_FLAG = 'fe.ux.chipPickKeepsSelector'   // IE 2026 10 13 / ODOO-5800

export function chipPickKeepsSelector_on(setting) {   // IE 2026 10 13 / ODOO-5800: чтение флага (нет читателя / ошибка — ВКЛ)
    try { return typeof setting === 'function' ? setting(CHIP_PICK_KEEPS_SELECTOR_FLAG, true) !== false : true } catch (e) { return true }
}

const isObj = (x) => !!x && typeof x === 'object' && !Array.isArray(x)
const hasVal = (v) => isObj(v) && v.value !== undefined && v.value !== null && v.value !== ''
const LIST_CONDS = ['in', '!in']

// списочное условие строки стола (значения — в attrs)
export function chipRow_isListCond(condition) {   // IE 2026 10 13 / ODOO-5800
    return LIST_CONDS.includes(String(condition || ''))
}

// строка стола привязана к виджету-селектору и отбирает списком — селекторная, в какой бы форме ни лежало значение
export function chipRow_isWidgetSelector(row) {   // IE 2026 10 13 / ODOO-5800
    return isObj(row) && !!row.widget && (chipRow_isListCond(row.condition) || /selector/.test(String(row.condition || '')))
}

// значения строки / записи истории: attrs (включённые) и rightValue (если в нём значение) — без повторов, в порядке attrs → rightValue
export function chipRow_values(row) {   // IE 2026 10 13 / ODOO-5800
    const out = [], seen = new Set()
    const push = (v) => { if (!hasVal(v)) return; const k = String(v.value); if (seen.has(k)) return; seen.add(k); out.push(v.value) }
    for (const a of (isObj(row) && Array.isArray(row.attrs) ? row.attrs : [])) { if (isObj(a) && a.use !== false) push(a.rightValue) }
    if (isObj(row)) push(row.rightValue)
    return out
}

// строка «in» / «!in» со значением в rightValue и пустым attrs → значение в attrs, rightValue — плейсхолдер (тип / сегмент сохраняются). Меняет строку на месте;
// true — строка изменена
export function chipRow_inToList(row) {   // IE 2026 10 13 / ODOO-5800
    if (!isObj(row) || !chipRow_isListCond(row.condition) || !hasVal(row.rightValue)) return false
    if (Array.isArray(row.attrs) && row.attrs.some(a => isObj(a) && a.use !== false && hasVal(a.rightValue))) return false
    const rv = row.rightValue
    const item = { value: rv.value, attr_type: rv.attr_type || 'AttrLink', relation_segment: rv.relation_segment || '' }
    if (rv.valueStr !== undefined && rv.valueStr !== null && rv.valueStr !== '') item.valueStr = rv.valueStr
    row.attrs = [{ use: true, rightValue: item }]
    row.rightValue = { ...rv, value: '', valueStr: '' }
    return true
}

// одно выбранное значение для строки стола: списочное условие — в attrs, иначе — rightValue (как раньше). Меняет строку на месте
export function chipRow_setSingle(row, value, valueStr, segment) {   // IE 2026 10 13 / ODOO-5800
    if (!isObj(row)) return row
    const item = { value, valueStr, attr_type: 'AttrLink', relation_segment: segment || '' }
    if (chipRow_isListCond(row.condition)) {
        row.attrs = [{ use: true, rightValue: item }]
        row.rightValue = { ...(isObj(row.rightValue) ? row.rightValue : {}), value: '', valueStr: '', attr_type: 'AttrLink', relation_segment: segment || '' }
    } else {
        row.rightValue = item
        row.attrs = []
    }
    return row
}
